import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import {CampaignListAPI} from "./../../../API/Sales/CampaignAPI";
import Sidebar from "./../Common/Sidebar";
import Header from "./../Common/Header";
import Loader from "./../../Loader";
import PopupDelete from "./../../PopupDelete";
import Paginate from "./../../../utils/Pagination";

const Campaign = () =>{

    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(false);
    //const [delheading, setDelHeading] = useState("");
    //const [delmessage, setDelMessage] = useState("");
    //const [showModal, setShowModal] = useState(false);
    //const [deletecampaignid, setDeleteCampaignId] = useState("");
    //const [iscampaigndelete, setIsCampaignDelete] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const perpagedata = 20;


    useEffect(() => {

        CampaignListAPI(setCampaigns, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+usersList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }



    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">                
                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Campaigns</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">

                            <div className="card-body">

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                												
                                                
                                                <th>Campaign Name</th>
                                                <th>Team</th>
                                                {/*<th style={{ width: "30%" }}>Progress</th>
                                                <th>Not Interested</th>
                                                <th>No Response</th>
                                                <th style={{ width: "10%" }}>Converted</th>
                                                <th style={{ width: "10%" }}>Conversion %</th>*/}
                                                <th>Status</th>
                                                <th>Created On</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="5">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (campaigns && campaigns.length > 0  ? 
                                                ( campaigns.map(campaign => 
                                                    (
                                            
                                                        <tr key={campaign.id}>
                                                            <td>{campaign.name}</td>
                                                            <td>{campaign.team_person}</td>
                                                            {/*<td>
                                                                <ul className="list-progress">
                                                                    <li>
                                                                        <h6>{campaign.fresh_leads}</h6>
                                                                        <p>Fresh</p>
                                                                    </li>
                                                                    <li>
                                                                        <h6>{campaign.warm_leads}</h6>
                                                                        <p>Warm</p>
                                                                    </li>
                                                                    <li>
                                                                        <h6>{campaign.today_followups}</h6>
                                                                        <p>Followup Today</p>
                                                                    </li>
                                                                    <li>
                                                                        <h6>{campaign.pending_followups}</h6>
                                                                        <p>Followup Pending</p>
                                                                    </li>
                                                                    
                                                                </ul>
                                                            </td>*/}
                                                            <td>
                                                                {campaign.deleted_at ?
                                                                    <span className="badge badge-pill bg-danger">Deactive</span>
                                                                :
                                                                    <span className="badge badge-pill bg-success">Active</span>
                                                                }
                                                            </td>
                                                            <td>{moment(campaign.created_at).format('DD-MMM-YYYY')}</td>
                                                            <td>
                                                                <Link to={`/sales/campaign-report/${campaign.id}`} >
                                                                    {/*<span className="badge badge-pill bg-success">View Report</span>*/}                                                                    
                                                                    <i class="ti ti-chart-bar fs-25"></i>
                                                                </Link>
                                                                
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="5">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        {pagecount > 1 ?
                        <div className="row pagination-section">

                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>

        {/*<PopupDelete message={delmessage} title={delheading} modalstatus={showModal} btnClickDelete={handleDeleteCampaign} btnClickClose={hideDeletePopup} />*/}

    </div>
    )
}

export default Campaign;